interface HubSectionDescriptionProps {
  description?: string;
  descriptionColor?: string;
}

const HubSectionDescription = ({ description, descriptionColor }: HubSectionDescriptionProps) =>
  !!description && (
    <div style={{ color: descriptionColor }} className="font-normal leading-normal text-xs whitespace-pre-wrap">
      {description}
    </div>
  );

export default HubSectionDescription;
